var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasIntegrationsEnabled)?_c('router-link',{staticClass:"navbar-item",attrs:{"title":_vm.t('navbar.integrations'),"to":{ name: 'integrations' }}},[_c('NavbarIcon')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }